import { render, staticRenderFns } from "./ExpedienteitemAutomodal.vue?vue&type=template&id=9346991a&"
import script from "./ExpedienteitemAutomodal.vue?vue&type=script&lang=js&"
export * from "./ExpedienteitemAutomodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports